import { cva, type VariantProps } from 'class-variance-authority';

export const textVariants = cva('', {
  variants: {
    variant: {
      d1: 'font-heading text-d1 leading-d1',
      d2: 'font-heading text-d2 leading-d2',
      d3: 'font-heading text-d3 leading-d3',
      b1: 'font-body text-b1 leading-b1',
      b2: 'font-body text-b2 leading-b2',
      b3: 'font-body text-b3 leading-b3',
      b4: 'font-body text-b4 leading-b4',
      b5: 'font-body text-b5 leading-b5',
      l1: 'font-body text-l1 leading-l1',
      l2: 'font-body text-l2 leading-l2',
    },
    color: {
      default: 'text-body',
      heading: 'text-heading',
      white: 'text-white',
      subtext: 'text-subtext',
      neutral: 'text-neutral-700',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
    weight: {
      light: 'font-light',
      regular: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
  },
  defaultVariants: {
    variant: 'b4',
    color: 'default',
    weight: 'regular',
  },
});

export type TextVariantProps = VariantProps<typeof textVariants>;
